const configuration = {
    apiUrl: process.env.REACT_APP_API_URL,
};
 
export default configuration;